// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","footerBtn":"reports-journal_footerBtn__iM7+U","btn":"reports-journal_btn__COF93","icon":"reports-journal_icon__Vcobk"};